// Pseudo random IDs, intended for non security related uses. E.g. generate keys for React components
export default function generateRandomId(prefix = '') {
  return `${prefix}_${Math.random().toString(36).substr(2, 9)}`;
}
